import React from 'react'
import { createCssClass } from '../../helpers/common';

// css
import './RadioBoxInput.css';

interface Props extends React.HTMLProps<HTMLInputElement> {
  id: string;
  name: string;
  selectedValue: string;
  options: {
    id: string,
    value: string,
    label: React.ReactNode | string,
    disabled?: boolean | (() => boolean)
  }[];
}

const RadioBoxInput: React.FC<Props> = ({ id, name, selectedValue, options, ...rest }) => {
  return (
    <div className={createCssClass(['radiobox-input', name])}>

      {options.map((option, index) => (
        <React.Fragment key={index}>
          <div className="radio-group">
            <input
              {...rest}
              type="radio"
              id={option.id}
              name={name}
              value={option.value}
              checked={option.value === selectedValue}
              disabled={typeof option.disabled === 'function' ? option.disabled() : option.disabled}
            />
            <label htmlFor={option.id}>{option.label}</label>
          </div>
        </React.Fragment>
      ))}

    </div>
  )
}

export default RadioBoxInput;